import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { map, uniqBy } from 'lodash';
import { Divider } from '@mui/material';
import { widgetDataSelector } from 'app/store/selectors/dashboards';
import WidgetContainer from 'app/pages/Project/ProductionManagement/Dashboards/Widgets/WidgetContainer/WidgetContainer';
import classes from 'app/pages/Project/ProductionManagement/Dashboards/Widgets/GlobalStatusWidget/styles.scss';
const GlobalStatusWidget = ({ widget, stepProjects, progressionStatus, steps }) => {
    const widgetsData = useSelector(widgetDataSelector(widget.id));
    const noSteps = steps.length === 0;
    const cardContent = () => {
        if (noSteps) {
            return _jsx("p", { style: { fontSize: '20px' }, children: "No steps were set" });
        }
        const taskSteps = map(steps, (step) => {
            const selectedStep = stepProjects[step];
            if (selectedStep.metaStep)
                return selectedStep.metaStepInst;
            return selectedStep;
        });
        const test = uniqBy(taskSteps, (step) => step.id);
        return (_jsxs("div", { children: [_jsxs("div", { className: classes.gridContainer, children: [_jsx("span", {}), _jsx("span", { className: classes.headerElement, children: "Done" }), _jsx("span", { className: classes.headerElement, children: "To do" }), _jsx("span", { className: classes.headerElement, children: "Wip" })] }), _jsx(Divider, { sx: { marginBottom: '10px' } }), test.map((step) => {
                    const stepData = widgetsData === null || widgetsData === void 0 ? void 0 : widgetsData[`${step === null || step === void 0 ? void 0 : step.id}`];
                    if (!stepData)
                        return;
                    return (_jsxs("div", { className: classes.gridContainer, "data-testid": `global-status-step-${step.id}`, children: [_jsx("span", { className: classes.stepTitle, children: step.name }), _jsx("span", { className: classes.stepData, style: {
                                    border: `4px solid #7AD537`,
                                }, children: stepData.done }), _jsx("span", { className: classes.stepData, style: {
                                    border: `4px solid #55BDDD`,
                                }, children: stepData.todo }), _jsx("span", { className: classes.stepData, style: {
                                    border: `4px solid #FFDA47`,
                                }, children: stepData.wip })] }, step.id));
                })] }));
    };
    return (_jsx(WidgetContainer, { customStyleContent: true, widget: widget, displayActionButton: false, displayError: noSteps, children: cardContent() }));
};
export default GlobalStatusWidget;
